export default __webpack_public_path__ + "static/media/FurnitureItem13.15eea325.png";